import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Check, Clipboard } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { copyConversationText, formatConversationCopy } from '../../helpers/conversationBank';

const CopyableResponse = ({
  text,
  placeholderContext,
  onCopied,
  buttonLabel = 'Copy',
  className = ''
}) => {
  const [copied, setCopied] = useState(false);
  const display = formatConversationCopy(text, placeholderContext);

  const onCopy = async e => {
    e.stopPropagation();
    try {
      await copyConversationText(text, placeholderContext);
      setCopied(true);
      toast.success('Copied');
      onCopied && onCopied();
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      toast.error('Could not copy. Please copy the text manually.');
    }
  };

  if (!display) return null;

  return (
    <div className={className}>
      <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-start">
        <p className="cb-response-text mb-2 mb-sm-0 flex-grow-1 pr-sm-3">{display}</p>
        <Button
          variant={copied ? 'success' : 'outline-dark'}
          size="sm"
          className="cb-copy-btn flex-shrink-0 align-self-stretch align-self-sm-start"
          onClick={onCopy}
        >
          {copied ? <Check className="mr-1" /> : <Clipboard className="mr-1" />}
          {copied ? 'Copied' : buttonLabel}
        </Button>
      </div>
    </div>
  );
};

export default CopyableResponse;
